/* eslint-disable indent */
/* eslint-disable quotes */
/* eslint-disable no-unused-vars */
import React from "react";
import Heading from "../../components/Heading";
import "./style.scss";
import AreaList from "./AreaList";

const AreaManagement = () => {
  return (
    <div className="p-1">
      <Heading title="Area Management" />
      <div className="area-management-container">
        <AreaList />
      </div>
    </div>
  );
};

export default AreaManagement;
